import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);

// Register custom service worker for push notifications
// CRITICAL: VitePWA was previously overwriting this SW with a Workbox-generated one
// that had NO push event handler. VitePWA has been removed to fix this.
if ('serviceWorker' in navigator) {
  const maintainPush = () => {
    if (document.visibilityState !== 'visible' || !navigator.onLine) return;
    import('./lib/pushNotifications')
      .then(({ maintainPushSubscription }) => maintainPushSubscription({ createIfMissing: true }))
      .catch((error) => console.error('[Push] Automatic subscription repair failed:', error));
  };

  window.addEventListener('load', () => {
    setTimeout(async () => {
      try {
        // Unregister ALL old service workers first (including VitePWA's Workbox SW)
        const registrations = await navigator.serviceWorker.getRegistrations();
        for (const reg of registrations) {
          if (reg.active) {
            const swUrl = reg.active.scriptURL;
            // Unregister any SW that is NOT our custom push-capable sw.js
            // This catches VitePWA's workbox-generated SWs and old versions
            if (!swUrl.endsWith('/sw.js')) {
              await reg.unregister();
              console.log('[SW] Unregistered conflicting SW:', swUrl);
            }
          }
        }
        
        // Register our custom push-capable service worker with update check
        const registration = await navigator.serviceWorker.register('/sw.js', { 
          scope: '/',
          updateViaCache: 'none' // Always check server for SW updates
        });
        
        // Force update check to ensure latest SW is active
        registration.update().catch(() => {});
        maintainPush();
        
        console.log('[SW] Custom push SW registered successfully');
      } catch (err) {
        console.error('[SW] Registration failed:', err);
      }
    }, 1000);
  });

  window.addEventListener('online', maintainPush);
  document.addEventListener('visibilitychange', maintainPush);
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data?.type === 'PUSH_SUBSCRIPTION_CHANGED') maintainPush();
  });
  window.setInterval(maintainPush, 6 * 60 * 60 * 1000);
}
